import { render, staticRenderFns } from "./IgButton.vue?vue&type=template&id=50a2c055&"
import script from "./IgButton.vue?vue&type=script&lang=js&"
export * from "./IgButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports